import { combineReducers } from 'redux';
import {
    UPDATE_FORM_FIELD,
    DIRECTIONS_REQUEST,
    DIRECTIONS_SUCCESS,
    DIRECTIONS_FAILURE,
    SELECT_CURRENT_TRIP,
    LOAD_CONFIG,
    PRINT_PAGE //Feature_issue-9 Changes -- Vishal Chauhan
} from '../actions';


const formReducer = (state = {}, action) => {
    if (action.type === UPDATE_FORM_FIELD) {
        const {name, value, errors, params} = action.payload;
        return {
            loading: false,
            error: null,
            fields: {
                ...state.fields,
                [name]: {
                    ...state.fields[name],
                    ...params,
                    errors,
                    value
                }
            }
        };
    }
    return state;
};

const initialDirectionsState = {
    loading: false,
    error: null,
    trips: [],
    currentTrip: null,

};
const directionsReducer = (state = initialDirectionsState, action) => {
    if (action.type === DIRECTIONS_REQUEST) {
        return {
            loading: true,
            error: null,
            trips: [],
            currentTrip: null
        };
    }
    if (action.type === DIRECTIONS_FAILURE) {
        return {
            loading: false,
            error: action.payload,
            trips: [],
            currentTrip: null
        };
    }
    //comes to this point when direction button is clicked and result is received
    //currently being called from actions>>index.js>>fetchDirections method
    if (action.type === DIRECTIONS_SUCCESS) {
        const res = action.payload;
        const error = res.data.error ? res.data.error : null;
        //Stores all trips
        let trips = (res.data.plan && res.data.plan.itineraries) ? res.data.plan.itineraries : [];
        //Feature_issue-84 Changes -- Vishal Chauhan  Start
        //Stores from stop id to show glimpse of areas on the map
        let fromStopId = (res.data.plan && res.data.plan.from.stopId)? res.data.plan.from.stopId : "";
        //Stores from stop id to show glimpse of areas on the map
        let toStopId = (res.data.plan && res.data.plan.to.stopId)? res.data.plan.to.stopId : "";
        //Feature_issue-84 Changes -- Vishal Chauhan  End
        trips.sort((a,b) => {
            const timeDiff = Math.abs(a.duration - b.duration);
            if (timeDiff < 2800) {
                return a.endTime - b.endTime;
            } else {
                return a.duration - b.duration;
            }
        });
        return {
            loading: false,
            error: error,
            trips: trips,
            currentTrip: null,
            fromStopId:fromStopId, //Feature_issue-84 Changes -- Vishal Chauhan
            toStopId:toStopId //Feature_issue-84 Changes -- Vishal Chauhan

        };
    }
    if (action.type === SELECT_CURRENT_TRIP) {
        const tripIndex = action.payload;
        // console.log('tripIndex', action.payload);
        if (state.currentTrip === tripIndex) {
            return {
                ...state,
                currentTrip: null
            };
        }
        return {
            ...state,
            currentTrip: tripIndex
        };
    }
    return state;
};


// TODO: Find a better solution for handling views
const viewReducer = (state = {currentView: 'PLANNER', previousView: 'PLANNER'}, action) => {
    if (action.type === UPDATE_FORM_FIELD) {
        if (action.payload.name === 'useMap' && action.payload.value === 'true') {
            return {
                previousView: 'DIRECTIONS',
                currentView: 'MAP'
            };
        }
        if (action.payload.name === 'useMap' && action.payload.value === 'false') {
            return {
                previousView: state.currentView,
                currentView: state.previousView
            };
        }
    }
    if (action.type === DIRECTIONS_REQUEST) {
        if (state.currentView === 'MAP') {
            return state;
        }
        if ((state.currentView !== 'MAP') && (action.payload.useMap === 'true')) {
            return {
                previousView: 'DIRECTIONS',
                currentView: 'MAP'
            };
        }
        return {
            previousView: state.currentView,
            currentView: 'DIRECTIONS'
        };
    }
    //Feature_issue-9 Changes -- Vishal Chauhan  Start
    if (action.type === PRINT_PAGE) {
        return {
            previousView: state.currentView,
            currentView: 'PRINT'
        };
    }
    //Feature_issue-9 Changes -- Vishal Chauhan  End
    return state;
};

const initialConfigState = {
    mapboxToken: '',
    swBounds: {lat: 24.396308, lng:-124.848974},
    neBounds: {lat: 49.384358, lng: -66.885444},
    // swBounds: {lat: 42.031638, lng: -71.080483832},
    // neBounds: {lat: 42.12650795, lng: -70.925458},
    useStrict: true,
    mapboxStyle: 'mapbox://styles/mapbox/streets-v9',
    // mapboxStyle: './public/learn/streets-v9-copy.json',
    // mapboxStyle: './public/learn/streets-v9-edited.json',
    loading: true
};
const configReducer = (state = initialConfigState, action) => {
    if (action.type === LOAD_CONFIG) {
        return {
            ...state,
            ...action.payload
        };
    }
    return state;
};

export default combineReducers({
    form: formReducer,
    directions: directionsReducer,
    view: viewReducer,
    config: configReducer
});
